__turbopack_context__.v({
  "additional": "apply-disclaimer-module-scss-module__v5KzLW__additional",
  "custom": "apply-disclaimer-module-scss-module__v5KzLW__custom",
  "generic": "apply-disclaimer-module-scss-module__v5KzLW__generic",
  "link": "apply-disclaimer-module-scss-module__v5KzLW__link",
  "not-eligible": "apply-disclaimer-module-scss-module__v5KzLW__not-eligible",
});
